import React from 'react'
import { BsTelephone } from 'react-icons/bs'
import { NavLink } from 'react-router-dom'
import logo from '../img/logo.jpg'

export default function Footer() {

    const handleScroll = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    return (
        <div className='flex justify-between items-center py-4 px-24 text-white max-md:px-5 max-sm:flex-col max-sm:gap-3'>
            <NavLink to={'#'} onClick={handleScroll} className='flex items-center gap-1 text-white text-2xl font-bold max-sm:text-xl'>
                <img src={logo} alt="Барс-Бишкек" className='w-16' />
                Центр-<span className='text-[#2947be]'>АККУМУЛЯТОРОВ</span>
            </NavLink>
            <div className='max-sm:grid max-sm:justify-items-center'>
                <NavLink className={'flex items-center gap-2'} to={'tel:0709 388 332'}>
                    <BsTelephone size={20} />0709 388 332 Служба доставки
                </NavLink>
            </div>
        </div>
    )
}
